/**
 * LINKURIOUS CONFIDENTIAL
 * Copyright Linkurious SAS 2012 - 2017
 *
 * Created by maximeallex on 2017-03-15.
 */

'use strict';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import {SafeHtml} from "@angular/platform-browser";

@Injectable()
export class TooltipService {
  public event$: Subject<OnOpeningTooltip|OnClosingTooltip> = new Subject();

  /**
   * Open a tooltip
   */
  public open(config: {
    content: string|SafeHtml;
    position: 'top'|'bottom'|'left'|'right';
    placement: any;
    truncation: number;
    copy: boolean;
    maxWidth: number;
  }): void {
    this.event$.next(new OnOpeningTooltip(config));
  }

  /**
   * Close a tooltip
   */
  public close(): void {
    this.event$.next(new OnClosingTooltip());
  }

  /**
   * Update the tooltip
   */
  public update(value: string|SafeHtml): void {
    this.event$.next(new OnUpdateTooltip(value));
  }
}

export class OnUpdateTooltip {
  public content: string|SafeHtml;

  constructor(value: string|SafeHtml) {
    this.content = value;
  }
}

export class OnOpeningTooltip {
  public content: string|SafeHtml;
  public position: 'top'|'bottom'|'left'|'right';
  public placement: any;
  public truncation: number;
  public copy: boolean;
  public maxWidth: number;

  constructor(config: {
    content: string|SafeHtml;
    position: 'top'|'bottom'|'left'|'right';
    placement: any;
    truncation: number;
    copy: boolean;
    maxWidth: number;
  }) {
    this.content = config.content;
    this.position = config.position;
    this.placement = config.placement;
    this.truncation = config.truncation;
    this.copy = config.copy;
    this.maxWidth = config.maxWidth;
  }
}

export class OnClosingTooltip {}
